import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useAppContext } from "./context/AppContext";
import LoginPage from "./pages/LoginPage";
import ContentLibraryPage from "./pages/ContentLibraryPage";
import { FirebaseRoute } from "./auth/FirebaseRoute";
import { Container } from "react-bootstrap";
import Navbar from "./components/Navbar";
import Preloader from "./components/Preloader";
import Particle from "./components/Particle";
// @ts-ignore CSS side-effect imports are handled by the bundler.
import "./style.css";
// @ts-ignore CSS side-effect imports are handled by the bundler.
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import Profile from "./pages/ProfilePage";
import { PatreonRoute } from "./auth/PatreonRoute";
import Footer from "./components/Footer";
import PatreonAuthCallback from "./auth/PatreonAuthCallback";
import ContentPlayerPage from "./pages/ContentPlayerPage";
import { TermsOfUse } from "./pages/TermsOfUse";
import { HelpPage } from "./pages/HelpPage";
import VideoDataManager from "./pages/admin/VideoDataManager";
import UserManager from "./pages/admin/UserManager";
import ServerLogs from "./pages/admin/ServerLogs";
import CountdownPage from "./pages/CountdownPage";

function AppLayout(): JSX.Element {
  const isCountdownPage = useLocation().pathname === "/1111";
  const layoutClassName = isCountdownPage
    ? "app-layout app-layout--countdown"
    : "app-layout";

  return (
    <div className={layoutClassName}>
      <Navbar />
      <Particle />
      <Container
        className={`page-container${isCountdownPage ? " page-container--countdown" : ""}`}
      >
        <Container
          className={`page-content${isCountdownPage ? " page-content--countdown" : ""}`}
        >
          <Routes>
            <Route path="/1111" element={<CountdownPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/patreon/callback" element={<PatreonAuthCallback />} />

            <Route path="/profile" element={<FirebaseRoute><Profile /></FirebaseRoute>} />
            <Route path="/help" element={<FirebaseRoute><HelpPage /></FirebaseRoute>} />

            <Route path="/" element={<PatreonRoute><ContentLibraryPage /></PatreonRoute>} />
            <Route path="/files" element={<PatreonRoute><ContentLibraryPage /></PatreonRoute>} />
            <Route path="/files/*" element={<PatreonRoute><ContentPlayerPage /></PatreonRoute>} />

            <Route path="/admin/serverLogs" element={<FirebaseRoute><ServerLogs /></FirebaseRoute>} />
            <Route path="/admin/userManager" element={<FirebaseRoute><UserManager /></FirebaseRoute>} />
            <Route path="/admin/videoDataManager" element={<FirebaseRoute><VideoDataManager /></FirebaseRoute>} />

            <Route path="/terms-of-service" element={<TermsOfUse />} />
          </Routes>
        </Container>
      </Container>
      {!isCountdownPage && <Footer />}
    </div>
  );
}

function App(): JSX.Element {
  const { isWaitingForData } = useAppContext();

  if (isWaitingForData) {
    return <Preloader message="Loading..." />;
  }

  return (
    <Router>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} pauseOnFocusLoss={false} pauseOnHover={true} closeOnClick theme="light" />
      <AppLayout />
    </Router>
  );
}

export default App;
